

export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_ADD_ITEM_FAIL = 'CART_ADD_ITEM_FAIL';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS';
export const CART_SAVE_PAYMENT_METHOD = 'CART_SAVE_PAYMENT_METHOD';
export const CART_SAVE_CUSTOMIZATION = 'CART_SAVE_CUSTOMIZATION';
export const CART_SAVE_VOUCHER = 'CART_SAVE_VOUCHER';
export const CART_REMOVE_VOUCHER = 'CART_REMOVE_VOUCHER';
export const CART_CLEAR_ITEMS = 'CART_CLEAR_ITEMS';
